import styled, { css } from 'styled-components'

const StyledEditableTextDivCell = styled.div`
  display: flex;
  justify-content: flex-start;
  ${props =>
    props.isDisabled &&
    css`
      cursor: not-allowed;
    `};
`

export default StyledEditableTextDivCell
